import React, { SyntheticEvent, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { StateModel } from '../../../redux/store';
import { Message } from '../../../api';
import Table from '../../../components/table/Table';
import { initGefahrgutTableConfig } from './GefahrgutTableConfig';
import {
  setAuftragField,
  setCurrentAuftragspositionen,
} from '../../../redux/actions/auftragserfassung';
import { setModalConfig } from '../../../redux/actions/modal';
import {
  searchGefahrgutklassen,
  searchUnnr,
  searchVerpackungen,
} from '../../../redux/actions/gefahrguterfassung';
import Button, { ButtonType } from '../../../components/button/Button';
import {
  createMessage,
  removeNotifications,
} from '../../../utils/notificationUtils';
import { FORM_VALIDATION } from '../../notification/Notification';
import { addNotifications } from '../../../redux/actions/notification';
import { ConfigModel } from '../../../models/ConfigModel';
import { initGefahrgutTableConfigGerstlauer } from './GefahrgutTableConfig_Gerstlauer';
import { GERSTLAUER } from '../admin/client-config-assembler';

interface GefahrgutProps {
  auftragserfassung: any;
  rowIndex: number;
  setModalConfig: (value: any, fieldName: string) => void;
  setCurrentAuftragspositionen: any;
  setCurrentGefahrgutklasseUnnr: (
    unnr: string,
    rowNumber: number | undefined
  ) => void;
  searchVerpackungen: (value: string) => void;
  addNotifications: (
    messages: Message[],
    placeHolderValues?: any,
    timeout?: number | null
  ) => void;
  searchGefahrgutklassen: (text: string, rowNumber: number | undefined) => void;
  searchUnnr: (text: string | undefined) => void;
  setAuftragField: (value: any, fieldname: string) => void;
  config: ConfigModel;
}

/**
 * Benutzererfassung-Component
 *
 * @returns {JSX.Element} Benutzererfassung-Component
 * @constructor
 */

const Gefahrgut = (props: GefahrgutProps) => {
  const searchGefahrgutklassen = (rowIndex: number, value: string) => {
    props.searchGefahrgutklassen(value, rowIndex);
  };

  const searchUnnr = (rowIndex: number, value: string) => {
    props.searchUnnr(value);
  };

  const searchVerpackungen = (rowIndex: number, value: string) => {
    props.searchVerpackungen(value);
  };

  /**
   * Setzt den Wert von der Spalte Unnr in Gefahrgutklasse.
   * Beide Spalten nutzen die gleiche Objektstruktur.
   *
   * @param selectedRow
   */
  const setGefahrgutklasseFromUnnr = (selectedRow: number) => {
    const tmpAuftragsgefahrgueter = [...auftragsgefahrgueter];
    if (
      tmpAuftragsgefahrgueter[selectedRow]['gefahrgutUnnr']?.id !== undefined
    ) {
      tmpAuftragsgefahrgueter[selectedRow]['gefahrgutklasse'] = {
        ...tmpAuftragsgefahrgueter[selectedRow]['gefahrgutUnnr'],
      };
    } else {
      tmpAuftragsgefahrgueter[selectedRow]['gefahrgutklasse'] = {
        bezeichnung: '',
      };
    }
    setAuftragsgefahrgueter(tmpAuftragsgefahrgueter);
  };

  /**
   * Setzt den Wert von der Spalte Gefahrgutklasse in Unnr.
   * Beide Spalten nutzen die gleiche Objektstruktur.
   *
   * @param selectedRow
   */
  const setUnnrFromGefahrgutklasse = (selectedRow: number) => {
    const tmpAuftragsgefahrgueter = [...auftragsgefahrgueter];
    if (
      tmpAuftragsgefahrgueter[selectedRow]['gefahrgutklasse']?.id !== undefined
    ) {
      tmpAuftragsgefahrgueter[selectedRow]['gefahrgutUnnr'] = {
        ...tmpAuftragsgefahrgueter[selectedRow]['gefahrgutklasse'],
      };
    } else {
      tmpAuftragsgefahrgueter[selectedRow]['gefahrgutUnnr'] = {
        unnr: '',
      };
    }
    setAuftragsgefahrgueter(tmpAuftragsgefahrgueter);
  };

  const initTableConfig = () => {
    if (props.config.auftragsresearchtableconfig === GERSTLAUER) {
      return initGefahrgutTableConfigGerstlauer(
        searchVerpackungen,
        searchGefahrgutklassen,
        searchUnnr
      );
    }
    return initGefahrgutTableConfig(
      searchVerpackungen,
      searchGefahrgutklassen,
      searchUnnr
    );
  };

  const [tableConfig, setTableConfig] = useState(initTableConfig());

  const [selectedRow, setSelectedRow] = useState<number | undefined>(undefined);
  const [auftragsgefahrgueter, setAuftragsgefahrgueter] = useState(
    props.auftragserfassung.currentAuftragpos[props.rowIndex]
      ?.auftragsgefahrgueter
      ? JSON.parse(
          JSON.stringify([
            ...props.auftragserfassung.currentAuftragpos[props.rowIndex]
              .auftragsgefahrgueter,
          ])
        )
      : []
  );

  const initGefahrgueterIdListe = () => {
    const init: any[] = [];

    auftragsgefahrgueter.map((auftragsgefahrgut: any) => {
      init.push(auftragsgefahrgut?.gefahrgutklasse?.id ?? undefined);
    });

    return init;
  };

  const [gefahrgueterIdListe, setGefahrgueterIdListe] = useState<
    (number | undefined)[]
  >(initGefahrgueterIdListe());

  /**
   * Setzt für die Spalten Unnr & Gefahrgutklasse die gegenseitigen Werte.
   * Unnr = empty -> Gefahrgutklasse = empty
   * Gefahrgutklasse = {Wert Object} -> Unnr = {Wert Object}
   */
  const gefahrgutklasseUnnrBinding = () => {
    if (selectedRow != undefined) {
      const tmpGefahrgueterIdList: (number | undefined)[] = JSON.parse(
        JSON.stringify(gefahrgueterIdListe)
      );

      if (!tmpGefahrgueterIdList[selectedRow])
        tmpGefahrgueterIdList[selectedRow] = undefined;
      if (
        auftragsgefahrgueter[selectedRow].gefahrgutUnnr.id !==
        tmpGefahrgueterIdList[selectedRow]
      ) {
        setGefahrgutklasseFromUnnr(selectedRow);
        tmpGefahrgueterIdList[selectedRow] =
          auftragsgefahrgueter[selectedRow].gefahrgutUnnr.id;
        setGefahrgueterIdListe(tmpGefahrgueterIdList);
      } else if (
        auftragsgefahrgueter[selectedRow].gefahrgutklasse.id !==
        tmpGefahrgueterIdList[selectedRow]
      ) {
        setUnnrFromGefahrgutklasse(selectedRow);
        tmpGefahrgueterIdList[selectedRow] =
          auftragsgefahrgueter[selectedRow].gefahrgutklasse.id;
        setGefahrgueterIdListe(tmpGefahrgueterIdList);
      }
    }
  };

  useEffect(() => {
    gefahrgutklasseUnnrBinding();
  }, [auftragsgefahrgueter]);

  useEffect(() => {
    initModal();
    removeNotifications();
  }, []);

  const initModal = () => {
    props.setModalConfig('Gefahrgut hinzufügen', 'title');
    props.setModalConfig('690px', 'height');
    props.setModalConfig('1400px', 'width');
  };

  const defaultRow: any = {
    laufendeNummer: '',
    anzahl: '',
    gefahrgutausloeser: '',
    nettoGewicht: '',
    bruttoGewicht: '',
    liter: '',
    nettoexplosivmasse: '',
    verpackung: {
      langBezeichnung: '',
    },
    gefahrgutUnnr: {
      unnr: '',
    },
    begrenztemenge: false,
    umweltgefaehrdend: false,
    gefahrgutklasse: {
      bezeichnung: '',
      sondervorschrift: '',
      gefahrzettel: '',
      klasse: '',
      abfall: false,
      klassifizierung: '',
      verpackungscode: '',
      version: '',
    },
  };

  /**
   * Setzt programmatisch die Nr. der Auftragsgefahrgueter.
   * -------------
   * 4 Fälle:
   * 1. positionsNummer gesetzt und Auftragsgefahrguet leer
   *  -> loeschen und updaten
   * 2. positionsNummer nicht gesetzt und Auftragsgefahrguet nicht leer
   *  -> positionsNummer hinzufuegen und updaten
   * 3. positionsNummer gesetzt und Auftragsgefahrguet nicht leer
   *  -> nichts tun
   * 4. positionsNummer nicht gesetzt und Auftragsgefahrguet leer
   *  -> nichts tun,
   *     eine leere Zeile ist immer in Form der
   *     defaultRow durch die Tabelle enthalten
   */
  const setPositionsNr = () => {
    let shouldUpdate = false;
    const tmpAuftragsgefahrgueter = [...auftragsgefahrgueter]
      .filter(auftragsgefahrgut => {
        if (
          // Fall 1, wird durch .filter herausgefiltert,
          // anschließend muss geupdated werden
          auftragsgefahrgut.laufendeNummer &&
          auftragsgefahrgutIsEmpty(auftragsgefahrgut)
        ) {
          shouldUpdate = true;
          return false;
        }
        return true;
      })
      .map((auftragsgefahrgut, rowIndex: number) => {
        if (
          auftragsgefahrgut.laufendeNummer &&
          auftragsgefahrgut.laufendeNummer != rowIndex + 1
        )
          auftragsgefahrgut.laufendeNummer = rowIndex + 1;
        if (
          // Fall 2
          !auftragsgefahrgut.laufendeNummer &&
          !auftragsgefahrgutIsEmpty(auftragsgefahrgut)
        ) {
          shouldUpdate = true;
          return { ...auftragsgefahrgut, laufendeNummer: rowIndex + 1 };
        } else {
          // Fall 3 & 4
          return auftragsgefahrgut;
        }
      });
    if (shouldUpdate) {
      setAuftragsgefahrgueter(tmpAuftragsgefahrgueter);
    }
  };

  useEffect(() => {
    setPositionsNr();
  }, [auftragsgefahrgueter]);

  const auftragsgefahrgutIsEmpty = (auftragsgefahrgut: any): boolean => {
    return (
      !auftragsgefahrgut?.gefahrgutUnnr?.id &&
      !auftragsgefahrgut?.gefahrgutklasse?.id &&
      !auftragsgefahrgut?.bruttoGewicht &&
      !auftragsgefahrgut?.nettoGewicht &&
      !auftragsgefahrgut?.verpackung?.id &&
      !auftragsgefahrgut?.anzahl &&
      !auftragsgefahrgut?.liter &&
      !auftragsgefahrgut.nettoexplosivmasse
    );
  };

  /**
   * Validiert und Bestätigt die Gefahrgut Informationen der Tabelle.
   * @param event
   */
  const onSubmitHandler = (event: SyntheticEvent) => {
    const tmpAuftragpos = [...props.auftragserfassung.currentAuftragpos];
    const tmpAuftragsgefahrgueter = [...auftragsgefahrgueter];

    tmpAuftragsgefahrgueter.length > 1 && tmpAuftragsgefahrgueter.splice(-1);
    let isValid = true;
    let mitGefahrgut = false;
    const messages: Message[] = [];
    tmpAuftragsgefahrgueter?.forEach(
      (auftragsgefahrgut: any, index: number) => {
        if (
          auftragsgefahrgut.nettoGewicht ||
          auftragsgefahrgut.liter ||
          auftragsgefahrgut.gefahrgutklasse?.id ||
          auftragsgefahrgut.verpackung?.id ||
          auftragsgefahrgut.anzahl ||
          auftragsgefahrgut.bruttoGewicht
        ) {
          if (!auftragsgefahrgut.nettoGewicht && !auftragsgefahrgut.liter) {
            messages.push(
              createMessage(
                'Bitte füllen Sie Nettogewicht oder Liter aus.',
                FORM_VALIDATION,
                [],
                'auftragsgefahrgueter[' + index + '].nettoGewicht'
              )
            );
            isValid = false;
          }
          if (auftragsgefahrgut.nettoGewicht && auftragsgefahrgut.liter) {
            messages.push(
              createMessage(
                'Bitte füllen Sie entweder Nettogewicht oder Liter aus.',
                FORM_VALIDATION,
                [],
                'auftragsgefahrgueter[' + index + '].nettoGewicht'
              )
            );
            isValid = false;
          }

          if (
            auftragsgefahrgut.nettoGewicht &&
            auftragsgefahrgut.bruttoGewicht &&
            parseFloat(auftragsgefahrgut.nettoGewicht) >
              parseFloat(auftragsgefahrgut.bruttoGewicht)
          ) {
            messages.push(
              createMessage(
                'Nettogewicht darf nicht größer sein als Bruttogewicht.',
                FORM_VALIDATION,
                [],
                'auftragsgefahrgueter[' + index + '].nettoGewicht'
              )
            );
            isValid = false;
          }
          if (!auftragsgefahrgut.gefahrgutklasse?.id) {
            messages.push(
              createMessage(
                'Feld ist ein Pflichtfeld. Bitte ausfüllen.',
                FORM_VALIDATION,
                [],
                'auftragsgefahrgueter[' + index + '].gefahrgutklasse'
              )
            );
            isValid = false;
          }
          if (
            !auftragsgefahrgut.gefahrgutUnnr?.unnr &&
            //#81740 "0" soll wegen leeren Behältern möglich sein.
            auftragsgefahrgut.gefahrgutUnnr?.unnr === ''
          ) {
            messages.push(
              createMessage(
                'Feld ist ein Pflichtfeld. Bitte ausfüllen.',
                FORM_VALIDATION,
                [],
                'auftragsgefahrgueter[' + index + '].gefahrgutUnnr'
              )
            );
            isValid = false;
          }
          if (!auftragsgefahrgut.verpackung?.id) {
            messages.push(
              createMessage(
                'Feld ist ein Pflichtfeld. Bitte ausfüllen.',
                FORM_VALIDATION,
                [],
                'auftragsgefahrgueter[' + index + '].verpackung'
              )
            );
            isValid = false;
          }
          if (!auftragsgefahrgut.anzahl) {
            messages.push(
              createMessage(
                'Feld ist ein Pflichtfeld. Bitte ausfüllen.',
                FORM_VALIDATION,
                [],
                'auftragsgefahrgueter[' + index + '].anzahl'
              )
            );
            isValid = false;
          }
          if (!auftragsgefahrgut.bruttoGewicht) {
            messages.push(
              createMessage(
                'Feld ist ein Pflichtfeld. Bitte ausfüllen.',
                FORM_VALIDATION,
                [],
                'auftragsgefahrgueter[' + index + '].bruttoGewicht'
              )
            );
            isValid = false;
          }
          if (isValid) {
            mitGefahrgut = true;
          }
        }
      }
    );

    if (isValid) {
      tmpAuftragpos[props.rowIndex].mitGefahrguetern = mitGefahrgut;
      tmpAuftragpos[props.rowIndex].auftragsgefahrgueter =
        tmpAuftragsgefahrgueter;
      props.setCurrentAuftragspositionen(tmpAuftragpos);
      props.setAuftragField(
        tmpAuftragpos.filter(
          auftragsposition => auftragsposition.mitGefahrguetern
        ).length > 0,
        'mitGefahrguetern'
      );
      props.setModalConfig(false, 'show');
    } else {
      props.addNotifications(messages);
    }
  };

  const onCloseHandler = (event: SyntheticEvent) => {
    reset();
    props.setModalConfig(false, 'show');
    event.preventDefault();
  };

  const reset = () => {
    setAuftragsgefahrgueter(
      props.auftragserfassung.currentAuftragpos[props.rowIndex]
        ?.auftragsgefahrgueter
        ? JSON.parse(
            JSON.stringify([
              ...props.auftragserfassung.currentAuftragpos[props.rowIndex]
                .auftragsgefahrgueter,
            ])
          )
        : []
    );
  };

  return (
    <div className={'wrapper-gefahrgut'}>
      <div className='wrapper-form'>
        <div className={'wrapper-gefahrgut-table'}>
          <Table
            tableConfig={tableConfig}
            edit={true}
            name={'auftragsgefahrgueter'}
            setTableConfig={setTableConfig}
            data={auftragsgefahrgueter}
            setData={setAuftragsgefahrgueter}
            defaultEmptyRow={{ ...defaultRow }}
            tabSkipIndices={[0]}
            selectByAllTablecells={true}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
          />
          <div className={'hinweis'}>
            <b>Hinweis </b>
            <br />
            <br />
            <b>Verpackung: </b>Nach Eingabe eines Buchstaben öffnet sich die
            Auswahlliste
            <br />
            <br />
            <b>UNNR: </b> Nach Eingabe einer Zahl öffnet sich die Auswahlliste
            <br />
            <br />
            Nach dem Bestätigen schließt das Fenster nicht? Evtl. sind nicht
            alle Pflichtfelder gefüllt. <br />
            Scrollen Sie nach rechts um die Hinweise zu sehen <br />
            <br />
            Löschen eines Gefahrgutes: Markieren Sie eine Zeile und drücken Sie
            ENTF
            <br />
          </div>
        </div>
        <div className={'buttonpair'}>
          <Button onClickHandler={onCloseHandler}>Abbrechen</Button>
          <Button
            type={ButtonType.submit}
            onClickHandler={onSubmitHandler}
            tooltip={
              'Keine Reaktion? Sind alle Pflichtfelder gefüllt? -> nach rechts scrollen...'
            }
          >
            Bestätigen
          </Button>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
  resetToggle: state.Auftragserfassung.resetToggle,
  config: state.Config,
});

export default connect(mapStateToProps, {
  setModalConfig,
  setCurrentAuftragspositionen,
  searchVerpackungen,
  searchGefahrgutklassen,
  searchUnnr,
  addNotifications,
  setAuftragField,
})(Gefahrgut);
